const options = [
  {
    key: "",
    label: "sidebar.Dashboard",
    leftIcon: "speedometer.png"
  },

];
export default options;
